export enum CouponCheckboxDatahooks {
  SectionMessage = 'coupo-checkbox-section-message',
  Checkbox = 'coupon-checkbox-checkbox',
}
